export const AdminFilterPopUpDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case 'GET_ADMIN_POPUP_FILTER_DATA':
      return {
        ...state,
        popupFilterData: action.payload,
      };
    case 'API_START':
      if (action.payload === 'FETCH_ADMIN_POPUPFILTERDATA_DATA') {
        return {
          ...state,
          isLoadingAdminPopupFilterData: true,
        };
      } else {
        return state;
      }
    case 'API_END':
      if (action.payload === 'FETCH_ADMIN_POPUPFILTERDATA_DATA') {
        return {
          ...state,
          isLoadingAdminPopupFilterData: false,
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};
